import type { ScriptProperties } from "./ScriptProperties";
export interface ArgoCDGitCommitProperties {
    "Octopus.Action.ArgoCD.CommitMessageSummary": string;
    "Octopus.Action.ArgoCD.CommitMessageDescription": string;
    "Octopus.Action.ArgoCD.CommitMethod": string;
    "Octopus.Action.ArgoCD.PullRequest.Environments": string;
    "Octopus.Action.ArgoCD.PullRequest.EnvironmentsTemplateParameter": string;
    //Deprecated - keeping until we remove the old steps
    "Octopus.Action.ArgoCD.PullRequest.Mode": string;
    "Octopus.Action.ArgoCD.PullRequest.SpecificEnvironments": string;
    "Octopus.Action.ArgoCD.PullRequest.SpecificEnvironmentsTemplateParameter": string;
}
export interface ArgoCDImageUpdateProperties extends ScriptProperties, ArgoCDGitCommitProperties {
}
export enum GitCommitMethods {
    DirectCommit = "DirectCommit",
    PullRequest = "PullRequest",
    PerEnvironment = "PerEnvironment"
}
